// src/api/driverGroupAPI.js
import apiClient from './client';

const DRIVER_GROUPS_URL = '/api/v1/driver_groups/';
const COMPANY_DRIVER_GROUPS_URL = '/api/v1/companies/';

// Default form model (used internally in forms) - updated with DriverTariffId
export const defaultDriverGroupFormValues = {
  DriversGroupName: '',
  DriversGroupCompanyId: 0,
  DriversGroupEnabled: true,
  DriversGroupDiscountId: null,
  DriverTariffId: null
};

// Default display model (used internally for type checking) - updated with DriverTariffId
export const defaultDriverGroupValues = {
  DriversGroupId: 0,
  DriversGroupCompanyId: 0,
  DriversGroupName: '',
  DriversGroupEnabled: true,
  DriversGroupDiscountId: null,
  DriverTariffId: 0,
  DriversGroupCreated: '',
  DriversGroupUpdated: ''
};

// Get all driver groups with optional filtering
export const getDriverGroups = async (companyId, enabled) => {
  try {
    const params = {};
    if (companyId !== undefined) params.company_id = companyId;
    if (enabled !== undefined) params.enabled = enabled;

    const response = await apiClient.get(DRIVER_GROUPS_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching driver groups:', error);
    throw error;
  }
};

// Get all driver groups for a specific company
export const getCompanyDriverGroups = async (companyId, enabled) => {
  try {
    const params = enabled !== undefined ? { enabled } : {};
    const response = await apiClient.get(`${COMPANY_DRIVER_GROUPS_URL}${companyId}/driver_groups`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching driver groups for company ${companyId}:`, error);
    throw error;
  }
};

// Get a single driver group by ID
export const getDriverGroup = async (driverGroupId) => {
  try {
    const response = await apiClient.get(`${DRIVER_GROUPS_URL}${driverGroupId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching driver group ${driverGroupId}:`, error);
    throw error;
  }
};

// Create a new driver group
export const createDriverGroup = async (driverGroupData) => {
  try {
    const response = await apiClient.post(DRIVER_GROUPS_URL, driverGroupData);
    return response.data;
  } catch (error) {
    console.error('Error creating driver group:', error);
    throw error;
  }
};

// Update a driver group
export const updateDriverGroup = async (driverGroupId, driverGroupData) => {
  try {
    const response = await apiClient.put(`${DRIVER_GROUPS_URL}${driverGroupId}`, driverGroupData);
    return response.data;
  } catch (error) {
    console.error(`Error updating driver group ${driverGroupId}:`, error);
    throw error;
  }
};

// Delete a driver group
export const deleteDriverGroup = async (driverGroupId) => {
  try {
    await apiClient.delete(`${DRIVER_GROUPS_URL}${driverGroupId}`);
  } catch (error) {
    console.error(`Error deleting driver group ${driverGroupId}:`, error);
    throw error;
  }
};

// Get drivers in a driver group
export const getDriverGroupDrivers = async (driverGroupId, enabled) => {
  try {
    const params = enabled !== undefined ? { enabled } : {};
    const response = await apiClient.get(`${DRIVER_GROUPS_URL}${driverGroupId}/drivers`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching drivers for driver group ${driverGroupId}:`, error);
    throw error;
  }
};